import React, { useEffect } from 'react';

function HomeAdmin() {
    useEffect(() => {
        document.title = "Tổng quan";
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className='container'>
            Tổng quan
        </div>
    )
}

export default HomeAdmin;




